import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the datawatch API
 */
export class DatawatchService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getDatawatches(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var data = await this.makeGETRequest('/api/resource/data-watches' + params);		
		return data;
	}

	exportDatawatches(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/data-watches/export' + params);
	}
	
	async getDatawatch(watchId) {
		var data = await this.makeGETRequest('/api/resource/data-watches/' + watchId);		
		return data;
	}	
	
	async getDatawatchTest(watchId) {
		var data = await this.makeGETRequest('/api/resource/data-watches/' + watchId + '/test');		
		return data;
	}	
	
	async getIntegrationConfigs(paging)  {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/data-watches/integrations' + params);		
		return data;
	}	
	
	async saveDatawatch(watch, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/data-watches/' + watch.watchId, watch);
		} else {
			saved = await this.makePOSTRequest('/api/resource/data-watches', watch);
		}
		return saved;
	}	
	
	async deleteDatawatch(watchId) {		
		var result = await this.makeDELETERequest('/api/resource/data-watches/' + watchId);		
		return result;
	}
	
	async activateDatawatch(watchId) {	
		var result = await this.makePUTRequest('/api/resource/data-watches/' + watchId + '/activate');
		return result;
	}	

	async inactivateDatawatch(watchId) {	
		var result = await this.makePUTRequest('/api/resource/data-watches/' + watchId + '/inactivate');
		return result;
	}	
	
}	



